import React from "react";
import { Link } from "react-router-dom";
import DropdownMenu from "./DropdownMenu"; // Importing the dropdown component

export default function Header({ samparks, id }) {
  return (
    <div>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <ul className="navbar-nav">
          <li className="nav-item d-flex">
            <Link
              className="nav-link"
              data-widget="pushmenu"
              to="#"
              role="button"
              state={{ samparks: samparks, id: id }}
            >
              <i className="fas fa-bars text-dark"></i>
            </Link>
          </li>
        </ul>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <DropdownMenu />
          </li>
        </ul>
      </nav>
    </div>
  );
}
